import { style } from '@vanilla-extract/css';

export const figcaption = style({
  color: 'var(--post-section-text-color, var(--wt-image-source-color, var(--site-theme-text-on-background-color)))',
  fontStyle: 'var(--wt-image-source-style, normal)',
  fontFamily: 'var(--wt-image-source-font-family, var(--wt-font-family))',
  fontSize: 'var(--wt-image-source-font-size, var(--wt-font-size))',
  lineHeight: 'var(--wt-image-source-line-height-exact, 1.5)',
});
